
import axios from "axios";

 export const RestClient = axios.create({
  // baseURL:  "http://localhost:8000/api",
  baseURL:  "https://polite-bottles-flash.loca.lt/api",
  timeout: 10000, 
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
});